// Plain-English explanations for the Virtual Buyer metrics, shown in the
// InfoPopover next to each metric (detail cards + overview headers). Kept in one
// place so the detail and overview wording can't drift. Phrasing mirrors how the
// numbers are actually computed (backend/buyer/services/metrics.py).

export const METRIC_INFO = {
  signals:
    "How many of your 19 AI Trust Signals were surfaced about your company in this run's answers. (We can judge 18 of them in AI answers; HTTPS and Google Page 1 aren't observable there.)",
  visibility:
    "Across all the AI answers in this run, the share that mentioned your company at all.",
  sov:
    "Your share of every company AI named in this run: your slice of the conversation versus everyone else mentioned.",
  big5:
    "For each of the Big-5 question topics, how many of your questions had your company actually come up in the AI answers.",
  trend:
    "Your visibility across recent runs, oldest to newest.",
} as const;
